<template>
  <section class="section-search" :class="{'mt-4': !$mq.phone}">
    <div class="row section-search-filter">
      <div class="col-md-8 col-12 form-book-cleaner" :class="{'p-0': $mq.phone}">
        <div class="card shadow-sm">
          <div class="card-body">
            <div class="d-flex">
              <div class="flex-fill pr-2">
                <!-- Date -->
                <div class="form-group mb-0">
                  <label>{{ $t('message.booking.booking_step.date') }}</label>
                  <input type="text"
                         class="form-control -date-picker input-jumbo"
                         @change="updatePreBookingData('cleaning_date', $event)"
                         v-pikaday="selectedDate"
                         ref="cleaningDate" readonly>
                </div>
              </div>
              <div class="flex-fill pl-2">
                <!-- Time -->
                <div class="form-group mb-0">
                  <label>{{ $t('message.booking.booking_step.time') }}</label>
                  <div class="select-jumbo">
                    <select class="form-control" v-model="selectedTime"
                            @change="updatePreBookingData('cleaning_time', $event)">
                      <option :value="time" v-for="time in filteredTimes">{{ time }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>


            <!-- Filters -->
            <div class="pt-4">
              <h3 class="mb-0">{{ $t('message.professional.filters') }}</h3>
              <div class="d-flex justify-content-start align-items-center">
                <!-- Has Vacuum Cleaner -->
                <div class="mt-3 custom-control custom-checkbox mr-3" v-if="preBookingData.service_id === 1">
                  <input id="has_vacuum_cleaner"
                        type="checkbox"
                        name="has_vacuum_cleaner"
                        class="custom-control-input"
                        v-model="hasVacuumCleaner">
                  <label for="has_vacuum_cleaner" class="mb-0 custom-control-label">
                    {{ $t('message.professional.has_vacuum_cleaner') }}
                  </label>
                </div>
                <!-- Excellent Provider -->
                <div class="mt-3 custom-control custom-checkbox mr-3">
                  <input id="excellent_provider"
                        type="checkbox"
                        name="excellent_provider"
                        class="custom-control-input"
                        :true-value="1"
                        :false-value="0"
                        v-model="isExcellent">
                  <label for="excellent_provider" class="mb-0 custom-control-label">
                    {{ $t('message.professional.excellent_providers') }}
                  </label>
                </div>
                <!-- Vaccinated professional -->
                <div class="mt-3 custom-control custom-checkbox">
                  <input id="vaccinated_professional"
                        type="checkbox"
                        name="vaccinated_professional"
                        class="custom-control-input"
                        :true-value="1"
                        :false-value="0"
                        v-model="vaccinatedProfessional">
                  <label for="vaccinated_professional" class="mb-0 custom-control-label">
                    {{ $t('message.professional.vaccinated_professional') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="pt-4" v-if="!hasPlaceLocation">
              <h3 class="mb-2">{{ $t('message.booking.contact_step.location') }}</h3>
              <button class="btn btn-sm btn-outline-secondary" @click="showPinLocationModal()">
                <i class="fas fa-map-marker-alt text-danger"/> {{ $t('message.booking.contact_step.pin_location') }}
              </button>
            </div>
          </div>
          <!-- /.card -->
        </div>
        <!-- /.filter-box -->
      </div>

      <div class="col-md-4 p-0" v-if="$mq.desktop">
        <div class="card shadow-sm">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <ul class="list-unstyled mb-0">
                  <li>
                    <label>
                      <span v-html="$options.filters.serviceParentName(preBookingData.service_id, globalState.services)"></span> - <label>{{ globalState.cities[preBookingData.province_id] | multiLangName }}</label>
                    </label>
                  </li>
                  <li>
                    <div class="row">
                      <div class="col-4 p-0">
                        <label>{{ $t('message.booking.summary.date') }}</label>
                      </div>
                      <div class="col-8 p-0">
                        <label>{{ preBookingData.cleaning_date | summaryCleaningDate }}</label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="row">
                      <div class="col-4 p-0">
                        <label>{{ $t('message.booking.summary.time') }}</label>
                      </div>
                      <div class="col-8 p-0">
                        <label>{{ preBookingData.cleaning_time }}</label>
                      </div>
                    </div>
                  </li>
                  <li v-if="preBookingData.service_id === 1">
                    <div class="row">
                      <div class="col-4 p-0">
                        <label>{{ $t('message.booking.summary.duration') }}</label>
                      </div>
                      <div class="col-8 p-0">
                        <label>
                          {{ $t(globalState.allWorkHours[preBookingData.work_hour]) }}
                        </label>
                      </div>
                    </div>
                  </li>
                  <li v-else-if="preBookingData.service_items">
                    <div class="row">
                      <div class="col-4 p-0">
                        <label>{{ $t('message.booking.summary.list') }}</label>
                      </div>
                      <div class="col-8 p-0">
                        <label>
                          <div v-for="serviceItem in preBookingData.service_items">
                            {{ serviceItem | multiLangName }}: {{ serviceItem.count }} {{ serviceItem.item_unit | multiLangName }}
                          </div>
                        </label>
                      </div>
                    </div>
                  </li>
                  <li v-else>
                    <div class="row">
                      <div class="col-4 p-0">
                        <label>{{ $t('message.booking.summary.list') }}</label>
                      </div>
                      <div class="col-8 p-0">
                        <label>
                          {{ globalState.services[preBookingData.service_id] | multiLangName }}
                        </label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <hr>
                    <div class="d-flex">
                      <div class="flex-fill">
                        <label>{{ $t('message.booking.new_booking.subtotal') }}</label>
                      </div>
                      <div class="text-primary">
                        <label>{{ state.totalPrice | currency }}</label>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div><!-- /.row -->
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment-timezone'
  import timeHelpers from '../../../helpers/timeHelpers'

  export default {
    props: ['newBookingTime'],
    data () {
      return {
        search: '',
        selectedDate: null,
        selectedTime: '07:00',
        selectedPlaceSize: 1,
        selectedWorkHour: '2.0',
        sortBy: (this.$i18n.locale === 'th') ? 'name_th' : 'name_en',
        availableTimes: null,
        isAbleToLoadProfesionals: false,
        isExcellent: 0,
        hasVacuumCleaner: false,
        vaccinatedProfessional: false,
        covidTestProfessional: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        preBookingData: 'booking/getPreBookingData',
        professionals: 'booking/getProfessionals',
        state: 'booking/getState'
      }),
      filteredTimes () {
        return this.globalState.arrTimes.filter((time) => {
          if (this.availableTimes && this.availableTimes.indexOf(time) !== -1) {
            return time
          }
        })
      },
      hasPlaceLocation () {
        let result = false
        if (this.preBookingData && this.preBookingData.user_place && this.preBookingData.user_place.latitude && this.preBookingData.user_place.longitude) {
          result = true
        }
        return result
      }
    },
    watch: {
      newBookingTime () {
        this.selectedTime = this.newBookingTime
        const data = {key: 'cleaning_time', value: this.newBookingTime}
        this.$store.commit('booking/UPDATE_PRE_BOOKING_DATA', data)
        this.$parent.loadProfessionals()
      },
      hasVacuumCleaner () {
        this.$parent.updateHasVacuumCleaner(this.hasVacuumCleaner)
      },
      isExcellent () {
        this.loadByFilters()
      },
      vaccinatedProfessional () {
        this.loadByFilters()
      },
      covidTestProfessional () {
        this.loadByFilters()
      }
    },
    methods: {
      showPinLocationModal () {
        this.$parent.showPinLocationModal()
      },
      loadByFilters () {
        const filters = {
          isExcellent: this.isExcellent,
          vaccinatedProfessional: this.vaccinatedProfessional
        }
        this.$parent.loadByFilters(filters)
      },
      submitSearch (e) {
        const strSearch = e.target.value
        this.search = strSearch
        this.$parent.updateSearch(strSearch)
      },
      updatePreBookingData (attribute, e) {
        const data = {key: attribute, value: e.target.value}
        this.$store.commit('booking/UPDATE_PRE_BOOKING_DATA', data)
        // Prevent first load with on change cleaning date
        if (this.isAbleToLoadProfesionals) {
          this.$parent.loadProfessionals()
        } else {
          this.isAbleToLoadProfesionals = true
        }
        if (attribute === 'cleaning_date') {
          this.prepareAvailableTimes()
        }
      },
      setWorkHour () {
        this.selectedWorkHour = this.globalState.placeSizeWorkHours[this.selectedPlaceSize]
        const dataPlaceSize = {key: 'place_size_id', value: this.selectedPlaceSize}
        const dataWorkHour = {key: 'work_hour', value: this.selectedWorkHour}
        this.$store.commit('booking/UPDATE_PRE_BOOKING_DATA', dataPlaceSize)
        this.$store.commit('booking/UPDATE_PRE_BOOKING_DATA', dataWorkHour)
        this.$parent.loadProfessionals()
      },
      prepareAvailableTimes () {
        let nextAvailableTime = null
        if (this.isToday()) {
          nextAvailableTime = timeHelpers.getNextAvailableTime()
        }
        this.setAvailableTimes(nextAvailableTime)
      },
      setAvailableTimes (nextAvailableTime) {
        const arrTimes = this.globalState.arrTimes
        this.availableTimes = []
        if (nextAvailableTime) {
          const startIndex = arrTimes.indexOf(nextAvailableTime)
          for (let i = startIndex; i < arrTimes.length; i++) {
            this.availableTimes.push(arrTimes[i])
          }
          const index = this.availableTimes.indexOf(this.selectedTime)
          this.selectedTime = (index !== -1) ? this.availableTimes[index] : this.availableTimes[0]
        } else {
          this.availableTimes = arrTimes
        }
      },
      isToday () {
        return this.preBookingData.cleaning_date === moment().format('DD/MM/YYYY')
      }
    },
    mounted () {
      this.selectedDate = this.preBookingData.cleaning_date
      this.selectedTime = this.preBookingData.cleaning_time
      this.selectedPlaceSize = this.preBookingData.place_size_id
      this.selectedWorkHour = this.preBookingData.work_hour
      this.$refs.cleaningDate.value = this.selectedDate

      // Prepare available times
      this.prepareAvailableTimes()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/FilterProfessional.vue